import { IAction } from '../../../../../__core/Interfaces/IAction';
import { setGrantForAllModulesInProgressInitState } from './InitState';
import SHARING_ACTIONS from '../Actions/ActionTypes';

export const setGrantForAllModulesInProgressReducer = (
  state: Array<number> = setGrantForAllModulesInProgressInitState,
  action: IAction<number>
): Array<number> => {
  switch (action.type) {
    case SHARING_ACTIONS.SET_STUDENT_GRANT_FOR_ALL_MODULES_START:
      return [...state, action.payload];

    case SHARING_ACTIONS.SET_STUDENT_GRANT_FOR_ALL_MODULES_FINISH:
      return [...state.filter((value) => value !== action.payload)];

    default:
      return state;
  }
};
